import React, { Dispatch, SetStateAction, useCallback } from 'react';
import InterviewerLinkForm from './InterviewerLinkForm';
import { Box } from '@mui/material';
import AttributionIcon from '@mui/icons-material/Attribution';
import IconButton from '@mui/material/IconButton';
import { Tooltip } from 'framework/ui/mui-builder';
import { FormFieldsData } from 'framework/form';

const CopyLinkWithInterviewer = ({
  copyAction,
  getLink,
  isFormOpen,
  setIsFormOpen,
  isAdditional = false,
}: {
  copyAction: (str: string) => void;
  getLink: (values: FormFieldsData) => Promise<object | void>;
  isFormOpen: boolean;
  setIsFormOpen: Dispatch<SetStateAction<boolean>>;
  isAdditional?: boolean;
}) => {
  const openCloseIssueForm = useCallback(() => {
    setIsFormOpen(true);
  }, [setIsFormOpen]);

  const closeModal = useCallback(() => {
    setIsFormOpen(false);
  }, [setIsFormOpen]);

  return (
    <Box>
      <IconButton
        sx={{
          fontSize: '12px',
          p: 0,
          mr: '5px',
        }}
        onClick={openCloseIssueForm}
      >
        <Tooltip placement="top" title="Select interviewer">
          <AttributionIcon />
        </Tooltip>
      </IconButton>

      <InterviewerLinkForm
        getLink={getLink}
        copyAction={copyAction}
        closeModal={closeModal}
        modalOpen={isFormOpen}
        isAdditional={isAdditional}
      />
    </Box>
  );
};

export default CopyLinkWithInterviewer;
